import { render, staticRenderFns } from "./SubmissionConfirmation.vue?vue&type=template&id=5f5a923c&scoped=true"
import script from "./SubmissionConfirmation.vue?vue&type=script&lang=js"
export * from "./SubmissionConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5a923c",
  null
  
)

export default component.exports